/* Hard Nights newsletter: popup + footer band, Brevo double opt-in via fetch.
   No dependencies. Loaded with defer from sections/hn-newsletter-popup.liquid and sections/hn-newsletter-band.liquid. */
(function () {
  'use strict';
  if (window.__hnNewsletterInit) return;
  window.__hnNewsletterInit = true;

  var KEY_SUBSCRIBED = 'hnNlSubscribed';
  var KEY_DISMISSED_UNTIL = 'hnNlDismissedUntil';
  var DAY_MS = 86400000;

  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage blocked */ }
  }
  function isSubscribed() { return lsGet(KEY_SUBSCRIBED) === '1'; }

  /* ---------- Form ---------- */

  function setMessage(form, text, type) {
    var msg = form.querySelector('.hn-nl-form__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('is-error', type === 'error');
    msg.classList.toggle('is-success', type === 'success');
  }

  function markSuccess(form, track) {
    var location = form.getAttribute('data-hn-nl-location');
    lsSet(KEY_SUBSCRIBED, '1');
    form.classList.add('is-success');
    setMessage(form, form.getAttribute('data-msg-success'), 'success');
    if (track) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'newsletter_signup',
          newsletter_location: location,
          language: form.getAttribute('data-hn-nl-lang') || 'de'
        });
      } catch (e) { /* ignore */ }
    }
    try {
      document.dispatchEvent(new CustomEvent('hn:newsletter:subscribed', {
        detail: { location: location }
      }));
    } catch (e) { /* old browser */ }
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    event.preventDefault();
    if (form.getAttribute('data-busy') === '1' || form.classList.contains('is-success')) return;

    var email = form.querySelector('[name="EMAIL"]');
    var honeypot = form.querySelector('[name="email_address_check"]');
    var button = form.querySelector('[type="submit"]');
    var url = (form.getAttribute('action') || '').trim();
    var lang = form.getAttribute('data-hn-nl-lang') || 'de';

    if (email && !email.checkValidity()) {
      setMessage(form, form.getAttribute('data-msg-invalid'), 'error');
      email.focus();
      return;
    }
    if (honeypot && honeypot.value) {
      // Bot: pretend success, send nothing, no tracking.
      markSuccess(form, false);
      return;
    }
    if (!/^https:\/\/\S+$/i.test(url)) {
      console.warn('[HN Newsletter] Keine Brevo-Formular-URL hinterlegt (Abschnitts-Einstellung "brevo_form_url_' + lang + '"). Das Formular wurde nicht gesendet.');
      return;
    }

    setMessage(form, '', null);
    form.setAttribute('data-busy', '1');
    if (button) button.disabled = true;

    var data = new FormData(form);
    data.append('isAjax', '1');

    // no-cors: Brevo answers cross-origin; an opaque response counts as success.
    // A rejected fetch is a real network error and shows the error text.
    fetch(url, { method: 'POST', body: data, mode: 'no-cors', credentials: 'omit' })
      .then(function (response) {
        if (response.type === 'opaque') return { success: true };
        return response.json().catch(function () { return { success: response.ok }; });
      })
      .then(function (result) {
        if (!result || result.success === false) throw new Error('brevo-rejected');
        markSuccess(form, true);
      })
      .catch(function () {
        setMessage(form, form.getAttribute('data-msg-error'), 'error');
      })
      .then(function () {
        form.removeAttribute('data-busy');
        if (button) button.disabled = false;
      });
  }

  function initForms(root) {
    var forms = (root || document).querySelectorAll('[data-hn-nl-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-hn-nl-ready') === '1') return;
      form.setAttribute('data-hn-nl-ready', '1');
      form.addEventListener('submit', onSubmit);
    });
  }

  /* ---------- Popup ---------- */

  function initPopup() {
    var popup = document.querySelector('[data-hn-nl-popup]');
    if (!popup || popup.getAttribute('data-hn-nl-ready') === '1') return;
    popup.setAttribute('data-hn-nl-ready', '1');

    var panel = popup.querySelector('[data-hn-nl-panel]');
    var delayMs = (parseInt(popup.getAttribute('data-delay'), 10) || 8) * 1000;
    var pauseDays = parseInt(popup.getAttribute('data-pause-days'), 10) || 7;
    var designMode = popup.getAttribute('data-design-mode') === 'true' || !!(window.Shopify && window.Shopify.designMode);
    var lastFocus = null;
    var isOpen = false;

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function onKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) { event.preventDefault(); panel.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('hn-nl-lock');
      document.addEventListener('keydown', onKeydown, true);
      window.requestAnimationFrame(function () {
        popup.classList.add('is-open');
        panel.focus({ preventScroll: true });
      });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      if (!designMode && !isSubscribed()) {
        lsSet(KEY_DISMISSED_UNTIL, String(Date.now() + pauseDays * DAY_MS));
      }
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('hn-nl-lock');
      document.removeEventListener('keydown', onKeydown, true);
      window.setTimeout(function () { if (!isOpen) popup.hidden = true; }, 250);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    }

    Array.prototype.forEach.call(popup.querySelectorAll('[data-hn-nl-close]'), function (el) {
      el.addEventListener('click', function (event) { event.preventDefault(); close(); });
    });

    window.HnNewsletterPopup = { open: open, close: close };

    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (popup.closest('.shopify-section') && e.target === popup.closest('.shopify-section')) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (popup.closest('.shopify-section') && e.target === popup.closest('.shopify-section')) close();
      });
      return;
    }

    if (isSubscribed()) return;
    var until = parseInt(lsGet(KEY_DISMISSED_UNTIL) || '0', 10);
    if (until && until > Date.now()) return;

    /* Pandectes cookie banner: wait until it is closed / consent was given, then start the timer. */
    var startedAt = Date.now();
    var timer = null;
    var poll = null;

    function bannerVisible() {
      var banner = document.getElementById('pandectes-banner');
      if (banner && !banner.classList.contains('cc-invisible') && banner.getClientRects().length) return true;
      try {
        if (window.Pandectes && window.Pandectes.banner && window.Pandectes.banner.isOpen) return true;
      } catch (e) { /* ignore */ }
      return false;
    }
    /* Pandectes writes _pandectes_gdpr (base64 JSON) already before the decision with status "";
       after accept/deny/dismiss the status is filled. */
    function consentDecided() {
      var parts = document.cookie.split(/;\s*/);
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('_pandectes_gdpr=') !== 0) continue;
        try {
          var data = JSON.parse(window.atob(decodeURIComponent(parts[i].slice(16))));
          if (data && data.status) return true;
        } catch (e) {
          return true;
        }
      }
      return false;
    }
    function consentResolved() {
      if (bannerVisible()) return false;
      if (consentDecided()) return true;
      try {
        var P = window.Pandectes;
        if (P && P.hasInitialized && P.banner && P.banner.isApplicable === false) return true;
      } catch (e) { /* ignore */ }
      // Pandectes not present at all (blocked / removed): do not wait forever.
      if (!window.Pandectes && !document.getElementById('pandectes-banner') && Date.now() - startedAt > 15000) return true;
      return false;
    }

    function check() {
      if (timer || isOpen) return;
      if (!consentResolved()) return;
      window.clearInterval(poll);
      poll = null;
      timer = window.setTimeout(function () {
        timer = null;
        if (isSubscribed()) return;
        if (bannerVisible()) { poll = window.setInterval(check, 1000); return; }
        open();
      }, delayMs);
    }

    ['PandectesEvent_OnConsent', 'PandectesEvent_OnClose', 'PandectesEvent_OnHide'].forEach(function (name) {
      window.addEventListener(name, function () { window.setTimeout(check, 50); });
    });
    poll = window.setInterval(check, 1000);
    check();

    document.addEventListener('hn:newsletter:subscribed', function () {
      if (timer) { window.clearTimeout(timer); timer = null; }
      if (poll) { window.clearInterval(poll); poll = null; }
    });
  }

  function init() {
    initForms(document);
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initForms(e.target);
    initPopup();
  });
})();
